// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"Checkbox_checkboxContainer__XWYEM","checkbox":"Checkbox_checkbox__OcsHF","checkboxLabel":"Checkbox_checkboxLabel__NWNrZ"};